import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';

export default class OtherCar extends Phaser.GameObjects.Image {
  constructor(scene) {
    super(scene, 0, 0, ABCyaPhaser.Images.DEFAULT_ATLAS, 'Car1');
    scene.add.existing(this);

    this.scene = scene;
    this.workingWidth = 0;
    this.workingHeight = 0;

    this.vX = 0;
    this.vY = 0;
    this.destX = 0;
    this.destY = 0;
    this.workingWidth = 0;
    this.workingHeight = 0;

    this.baseSpeed = 0;
    this.destSpeed = 0;
    this.speedMod = 0;
    this.trackSpeed = 0;

    this.isOnscreen = true;
    this.timeOffscreen = 0;

    this.currentLaneNum = 0;

    this.STATE_CRUISING = 1;
    this.STATE_SPEEDING = 2;
    this.STATE_CRASHING = 5;

    this.workingWidth = this.getBounds().width;
    this.workingHeight = this.getBounds().height;

    this.boundries = {
      left: this.x - this.workingWidth / 2,
      right: this.x + this.workingWidth / 2,
      top: this.y - this.workingHeight / 2,
      bottom: this.y + this.workingHeight / 2
    };
  }

  reset(carType, accelerateType, laneNum, startX, destX, startY, destY, speed, trackSpeed) {
    this.angle = 0;
    this.scale = 1;
    this.setTexture(ABCyaPhaser.Images.DEFAULT_ATLAS, carType);
    this.state = this.STATE_CRUISING;
    this.alpha = 1.0;
    this.workingWidth = this.getBounds().width;
    this.workingHeight = this.getBounds().height;

    this.destX = destX;
    this.destY = destY;

    this.x = startX;
    let sY = startY;
    if (startY === 0) sY = -this.getBounds().height;
    this.y = sY;

    this.currentLaneNum = laneNum;
    this.baseSpeed = speed;
    this.destSpeed = speed;
    this.trackSpeed = trackSpeed;
    this.vY = speed;
    if (accelerateType === 1) {
      this.speedMod = this.baseSpeed * 2;
    }
    else if (accelerateType === 2) {
      this.speedMod = this.baseSpeed / 2;
    }
    else if (accelerateType === 3) {

    }

    this.setVisible(true);

    this.boundries = {
      left: this.x - this.workingWidth / 2,
      right: this.x + this.workingWidth / 2,
      top: this.y - this.workingHeight / 2,
      bottom: this.y + this.workingHeight / 2
    };
  };


  getNextPosBoundries() {
    const b = {
      left: this.nextPosX - this.workingWidth,
      right: this.nextPosX + this.workingWidth / 2,
      top: this.nextPosY - this.workingHeight / 2,
      bottom: this.nextPosY + this.workingHeight
    };
    return b;
  };

  doCrash(dir) {
    this.vX = 400 * dir;
    this.destX = dir >= 1 ? this.scene.mid.x * 2 + 50 : -50;
    this.state = this.STATE_CRASHING;
  };

  update(e, trackSpeedMod) {
    const tSpeed = !trackSpeedMod ? 0 : trackSpeedMod;

    if (this.baseSpeed < this.destSpeed) {
      this.baseSpeed += 1;
      if (this.baseSpeed > this.destSpeed) this.baseSpeed = this.destSpeed;
    }
    else if (this.baseSpeed > this.destSpeed) {
      this.baseSpeed -= 1;
      if (this.baseSpeed < this.destSpeed) this.baseSpeed = this.destSpeed;
    }

    this.vY = this.baseSpeed - (this.speedMod * tSpeed);// - (this.speedMod * trackSpeedMod);
    const dtime = e / 1000;

    this.y += this.vY * dtime;

    if (this.y < -this.workingHeight || this.y > this.scene.mid.y * 2 + this.workingHeight) {
      this.timeOffscreen += dtime;
      this.isOnscreen = false;
    }
    else {
      this.isOnscreen = true;
      this.timeOffscreen = 0;
      this.boundries = {
        left: this.x - this.workingWidth / 2,
        right: this.x + this.workingWidth / 2,
        top: this.y - this.workingHeight / 2,
        bottom: this.y + this.workingHeight / 2
      };
    }

    if (this.state === this.STATE_CRASHING) {
      this.crashUpdate(dtime);
    };
  };

  crashUpdate(dtime) {
    const newx = this.x + this.vX * dtime;
    if (this.vX > 0) {
      if (newx > this.destX) {
        this.x = this.destX;

        this.state = this.STATE_CRUISING;
        this.vX = 0;

      }
      else {
        this.x = newx;
        this.angle += this.vX * dtime;
        if (this.scaleX > 0.1) {
          this.scaleX -= 0.01;
        }
        if (this.scaleY > 0.1) {
          this.scaleY -= 0.01;
        }
      }
    }
    else {
      if (newx < this.destX) {
        this.x = this.destX;

        this.state = this.STATE_CRUISING;
        this.vX = 0;
      }
      else {
        this.x = newx;
        this.angle += this.vX * dtime;
        if (this.scaleX > 0.1) {
          this.scaleX -= 0.01;
        }
        if (this.scaleY > 0.1) {
          this.scaleY -= 0.01;
        }
      }
    }

    this.scene.spawnEffect(this.x, this.y, 'smoke');
  };
}